import React from 'react'

export default function ReportsAllCost() {
  return (
    <div>ReportsAllCost</div>
  )
}
